import React, { useState } from 'react';
import styles from './style.module.scss';
import { toast } from 'react-toastify';
import { useAuth } from '../../contexts/AuthContext';
import { CiUser, CiMail, CiPhone, CiCalendar, CiLock, CiCreditCard1 } from 'react-icons/ci';
import { BsArrowRight, BsArrowLeft, BsCheckCircle, BsShield, BsFileText } from 'react-icons/bs';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { api } from '../../services/apiClient';
import logo from '../../assets/logo.png';
import { useNavigate, Link } from 'react-router-dom';

const Cadastrar = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [aceiteTermos, setAceiteTermos] = useState(false);
  const [aceitePolitica, setAceitePolitica] = useState(false);
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [celular, setCelular] = useState('');
  const [cpfCnpj, setCpfCnpj] = useState('');
  const [dataNascimento, setDataNascimento] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const somenteNumeros = (str) => str.replace(/\D/g, '');

  // Validação de CPF
  const validarCPF = (cpf) => {
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false;
    
    const cpfArray = cpf.split('').map(el => +el);
    const rest = (count) => {
      return (cpfArray.slice(0, count-1)
        .reduce((soma, el, index) => (soma + el * (count-index)), 0) * 10) % 11 % 10;
    };
    return rest(10) === cpfArray[9] && rest(11) === cpfArray[10];
  };

  // Validação de CNPJ
  const validarCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (cnpj.length !== 14) return false;
    
    if (/^(\d)\1{13}$/.test(cnpj)) return false;
    
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado !== parseInt(digitos.charAt(0))) return false;
    
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    return resultado === parseInt(digitos.charAt(1));
  };

  // Validação de email
  const validarEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  // Validação de senha
  const validarSenha = (senha) => {
    return senha.length >= 6;
  };

  // Formatação de CPF/CNPJ
  const formatarCpfCnpj = (value) => {
    const numeros = somenteNumeros(value);
    if (numeros.length <= 11) {
      return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else {
      return numeros.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
  };

  // Formatação de celular
  const formatarCelular = (value) => {
    const numeros = somenteNumeros(value);
    return numeros.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  };

  // Formatação de data
  const formatarData = (value) => {
    const numeros = somenteNumeros(value);
    return numeros.replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3');
  };

  // Validação do step atual
  const validarStep = (stepAtual) => {
    const newErrors = {};

    if (stepAtual === 0) {
      if (!nome.trim()) newErrors.nome = 'Nome é obrigatório';
      if (!email.trim()) newErrors.email = 'Email é obrigatório';
      else if (!validarEmail(email)) newErrors.email = 'Email inválido';
      if (!celular.trim()) newErrors.celular = 'Celular é obrigatório';
      else if (somenteNumeros(celular).length !== 11) newErrors.celular = 'Celular deve ter 11 dígitos';
    }

    if (stepAtual === 1) {
      if (!cpfCnpj.trim()) newErrors.cpfCnpj = 'CPF ou CNPJ é obrigatório';
      else {
        const numeros = somenteNumeros(cpfCnpj);
        if (numeros.length === 11 && !validarCPF(numeros)) {
          newErrors.cpfCnpj = 'CPF inválido';
        } else if (numeros.length === 14 && !validarCNPJ(numeros)) {
          newErrors.cpfCnpj = 'CNPJ inválido';
        } else if (numeros.length !== 11 && numeros.length !== 14) {
          newErrors.cpfCnpj = 'CPF deve ter 11 dígitos ou CNPJ deve ter 14 dígitos';
        }
      }
      if (!dataNascimento.trim()) newErrors.dataNascimento = 'Data de nascimento é obrigatória';
      else if (somenteNumeros(dataNascimento).length !== 8) newErrors.dataNascimento = 'Data inválida';
    }

    if (stepAtual === 2) {
      if (!senha.trim()) newErrors.senha = 'Senha é obrigatória';
      else if (!validarSenha(senha)) newErrors.senha = 'Senha deve ter pelo menos 6 caracteres';
      if (!confirmarSenha.trim()) newErrors.confirmarSenha = 'Confirmação de senha é obrigatória';
      else if (senha !== confirmarSenha) newErrors.confirmarSenha = 'Senhas não coincidem';
      if (!aceiteTermos) newErrors.aceiteTermos = 'Você deve aceitar os termos de uso';
      if (!aceitePolitica) newErrors.aceitePolitica = 'Você deve aceitar a política de privacidade';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNextStep = () => {
    if (validarStep(step)) {
      setStep(step + 1);
    }
  };

  const handlePrevStep = () => {
    setStep(step - 1);
    setErrors({});
  };

  const handleFinalizarCadastro = async (e) => {
    e.preventDefault();
    
    if (!validarStep(2)) return;

    setLoading(true);

    try {
      const response = await api.post('/registrar', {
        nome,
        email,
        contato: somenteNumeros(celular),
        cpf: somenteNumeros(cpfCnpj),
        rg: '',
        nascimento: somenteNumeros(dataNascimento),
        password: senha,
        password_confirmation: confirmarSenha,
        cep: '',
        cidade: '',
        endereco: '',
        numero: '',
        complemento: '',
        uf: '',
      });

      setLoading(false);

      if (response.status === 200) {
        if (response.data.errors) {
          const errorArray = Object.keys(response.data.errors).reduce((acc, key) => {
            const errorsForKey = response.data.errors[key].map((error) => ({ field: key, message: error }));
            return acc.concat(errorsForKey);
          }, []);
          errorArray.map((erro) => {
            toast.error(erro.message, { position: 'top-right' });
          });
          return;
        }
        toast.success(`Cadastro feito com sucesso!!`, { position: 'top-right' });
        navigate('/');
      } else if (response.status === 201) {
        toast.success(`Cadastro feito com sucesso!!`, { position: 'top-right' });
        navigate('/');
      } else if (response.status === 500) {
        toast.success(`Cadastro feito com sucesso!!`, { position: 'top-right' });
        navigate('/');
      } else {
        toast.warn(`Falha ao fazer o cadastro, confirme seus dados`, { position: 'top-right' });
      }
    } catch (error) {
      setLoading(false);
      if (error.message === 'Request failed with status code 500') {
        toast.success(`Cadastro feito com sucesso!!`, { position: 'top-right' });
        navigate('/');
      } else {
        toast.error('Erro ao tentar fazer cadastro', { position: 'top-right' });
      }
    }
  };

  const steps = [
    { title: 'Dados Pessoais', icon: <CiUser />, description: 'Informações básicas' },
    { title: 'Documentos', icon: <CiCreditCard1 />, description: 'CPF e data de nascimento' },
    { title: 'Segurança', icon: <CiLock />, description: 'Senha e termos' }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        {/* Header */}
        <div className={styles.header}>
          <Link to="/" className={styles.logoContainer}>
            <img src={logo || "/placeholder.svg"} alt='Logo da empresa' className={styles.logo} />
          </Link>
          <h1>Criar Conta</h1>
          <p>Junte-se à nossa comunidade e comece a participar dos melhores bolões!</p>
        </div>

        {/* Progress Steps */}
        <div className={styles.stepsContainer}>
          {steps.map((stepItem, index) => (
            <div 
              key={index} 
              className={`${styles.stepItem} ${index <= step ? styles.active : ''} ${index < step ? styles.completed : ''}`}
            >
              <div className={styles.stepIcon}>
                {index < step ? <BsCheckCircle /> : stepItem.icon}
              </div>
              <div className={styles.stepContent}>
                <h3>{stepItem.title}</h3>
                <p>{stepItem.description}</p>
              </div>
              {index < steps.length - 1 && <div className={styles.stepConnector}></div>}
            </div>
          ))}
        </div>

        {/* Form Content */}
        <form className={styles.formContent} onSubmit={step === 2 ? handleFinalizarCadastro : (e) => e.preventDefault()}>
          {/* Step 0 - Dados Pessoais */}
          {step === 0 && (
            <div className={styles.stepContainer}>
              <h2>Dados Pessoais</h2>
              <p>Vamos começar com suas informações básicas</p>

              <div className={styles.inputGroup}>
                <label htmlFor="nome">Nome Completo</label>
                <div className={`${styles.inputContainer} ${errors.nome ? styles.error : ''}`}>
                  <CiUser className={styles.inputIcon} />
                  <input
                    id="nome"
                    type="text"
                    placeholder="Digite seu nome completo"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    className={styles.input}
                  />
                </div>
                {errors.nome && <span className={styles.errorMessage}>{errors.nome}</span>}
              </div>

              <div className={styles.inputGroup}>
                <label htmlFor="email">E-mail</label>
                <div className={`${styles.inputContainer} ${errors.email ? styles.error : ''}`}>
                  <CiMail className={styles.inputIcon} />
                  <input
                    id="email"
                    type="email"
                    placeholder="Digite seu e-mail"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={styles.input}
                  />
                </div>
                {errors.email && <span className={styles.errorMessage}>{errors.email}</span>}
              </div>

              <div className={styles.inputGroup}>
                <label htmlFor="celular">Celular</label>
                <div className={`${styles.inputContainer} ${errors.celular ? styles.error : ''}`}>
                  <CiPhone className={styles.inputIcon} />
                  <input
                    id="celular"
                    type="text"
                    placeholder="(00) 00000-0000"
                    value={celular}
                    onChange={(e) => setCelular(formatarCelular(e.target.value))}
                    maxLength={15}
                    className={styles.input}
                  />
                </div>
                {errors.celular && <span className={styles.errorMessage}>{errors.celular}</span>}
              </div>
            </div>
          )}

          {/* Step 1 - Documentos */}
          {step === 1 && (
            <div className={styles.stepContainer}>
              <h2>Documentos</h2>
              <p>Precisamos de alguns documentos para sua segurança</p>

              <div className={styles.inputGroup}>
                <label htmlFor="cpfCnpj">CPF ou CNPJ</label>
                <div className={`${styles.inputContainer} ${errors.cpfCnpj ? styles.error : ''}`}>
                  <CiCreditCard1 className={styles.inputIcon} />
                  <input
                    id="cpfCnpj"
                    type="text"
                    placeholder="000.000.000-00 ou 00.000.000/0000-00"
                    value={cpfCnpj}
                    onChange={(e) => setCpfCnpj(formatarCpfCnpj(e.target.value))}
                    maxLength={18}
                    className={styles.input}
                  />
                </div>
                {errors.cpfCnpj && <span className={styles.errorMessage}>{errors.cpfCnpj}</span>}
              </div>

              <div className={styles.inputGroup}>
                <label htmlFor="dataNascimento">Data de Nascimento</label>
                <div className={`${styles.inputContainer} ${errors.dataNascimento ? styles.error : ''}`}>
                  <CiCalendar className={styles.inputIcon} />
                  <input
                    id="dataNascimento"
                    type="text"
                    placeholder="DD/MM/AAAA"
                    value={dataNascimento}
                    onChange={(e) => setDataNascimento(formatarData(e.target.value))}
                    maxLength={10}
                    className={styles.input}
                  />
                </div>
                {errors.dataNascimento && <span className={styles.errorMessage}>{errors.dataNascimento}</span>}
              </div>
            </div>
          )}

          {/* Step 2 - Segurança */}
          {step === 2 && (
            <div className={styles.stepContainer}>
              <h2>Segurança</h2>
              <p>Crie uma senha segura e aceite nossos termos</p>

              <div className={styles.inputGroup}>
                <label htmlFor="senha">Senha</label>
                <div className={`${styles.inputContainer} ${errors.senha ? styles.error : ''}`}>
                  <CiLock className={styles.inputIcon} />
                  <input
                    id="senha"
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Digite sua senha (mín. 6 caracteres)"
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                    className={styles.input}
                  />
                  <button
                    type="button"
                    className={styles.passwordToggle}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                {errors.senha && <span className={styles.errorMessage}>{errors.senha}</span>}
              </div>

              <div className={styles.inputGroup}>
                <label htmlFor="confirmarSenha">Confirmar Senha</label>
                <div className={`${styles.inputContainer} ${errors.confirmarSenha ? styles.error : ''}`}>
                  <CiLock className={styles.inputIcon} />
                  <input
                    id="confirmarSenha"
                    type={showConfirmPassword ? 'text' : 'password'}
                    placeholder="Confirme sua senha"
                    value={confirmarSenha}
                    onChange={(e) => setConfirmarSenha(e.target.value)}
                    className={styles.input}
                  />
                  <button
                    type="button"
                    className={styles.passwordToggle}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                {errors.confirmarSenha && <span className={styles.errorMessage}>{errors.confirmarSenha}</span>}
              </div>

              <div className={styles.checkboxGroup}>
                <div className={`${styles.checkboxItem} ${errors.aceitePolitica ? styles.error : ''}`}>
                  <input
                    type="checkbox"
                    id="politica"
                    checked={aceitePolitica}
                    onChange={(e) => setAceitePolitica(e.target.checked)}
                    className={styles.checkbox}
                  />
                  <label htmlFor="politica" className={styles.checkboxLabel}>
                    <BsShield className={styles.checkboxIcon} />
                    Li e concordo com a{' '}
                    <Link to='/politica-de-privacidade' target="_blank">
                      <strong>Política de Privacidade</strong>
                    </Link>
                  </label>
                </div>

                <div className={`${styles.checkboxItem} ${errors.aceiteTermos ? styles.error : ''}`}>
                  <input
                    type="checkbox"
                    id="termos"
                    checked={aceiteTermos}
                    onChange={(e) => setAceiteTermos(e.target.checked)}
                    className={styles.checkbox}
                  />
                  <label htmlFor="termos" className={styles.checkboxLabel}>
                    <BsFileText className={styles.checkboxIcon} />
                    Li e concordo com os{' '}
                    <Link to='/termos-de-uso' target="_blank">
                      <strong>Termos de Uso</strong>
                    </Link>
                  </label>
                </div>
              </div>
            </div>
          )}

          {/* Navigation Buttons */}
          <div className={styles.navigationButtons}>
            {step > 0 && (
              <button
                type="button"
                onClick={handlePrevStep}
                className={`${styles.button} ${styles.buttonSecondary}`}
                disabled={loading}
              >
                <BsArrowLeft />
                Voltar
              </button>
            )}

            {step < 2 ? (
              <button
                type="button"
                onClick={handleNextStep}
                className={`${styles.button} ${styles.buttonPrimary}`}
              >
                Próximo
                <BsArrowRight />
              </button>
            ) : (
              <button
                type="submit"
                className={`${styles.button} ${styles.buttonPrimary}`}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <div className={styles.spinner}></div>
                    Criando conta...
                  </>
                ) : (
                  <>
                    Finalizar Cadastro
                    <BsCheckCircle />
                  </>
                )}
              </button>
            )}
          </div>
        </form>

        {/* Footer */}
        <div className={styles.footer}>
          <p>
            Já tem uma conta?{' '}
            <Link to="/login" className={styles.loginLink}>
              Faça login aqui
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Cadastrar;
